const header = [
  { text: 'Question', value: 'question' },
  { text: 'Hint', value: 'hint' },
  { text: 'Answer', value: 'answer' },
  { text: 'Action', value: 'actions', sortable: false }
]

export default header
